
import React from "react";
import { Button } from "@/components/ui/button";

const DashboardHeader: React.FC = () => {  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
      <h2 className="text-2xl font-bold tracking-tight text-corporate-primary-100">
        Admin Dashboard
      </h2>
    </div>
  );
};

export default DashboardHeader;
